export default "__VITE_ASSET__DZS4T$0H__"